import { render, staticRenderFns } from "./teshuzhuanye.vue?vue&type=template&id=c82420c4&scoped=true&"
import script from "./teshuzhuanye.vue?vue&type=script&lang=js&"
export * from "./teshuzhuanye.vue?vue&type=script&lang=js&"
import style0 from "./teshuzhuanye.vue?vue&type=style&index=0&id=c82420c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82420c4",
  null
  
)

export default component.exports